const QUESTIONSDATA = [
    {
        id: 1,
        question: `Who wrote the introduction to the English translation of Rabindranath Tagore’s Gitanjali?`,
        option1: `P.B. Shelley`,
        option2: `Alfred Tennyson`,
        option3: `W.B. Yeats`,
        option4: `T.S. Elliot`,
        correct: `W.B. Yeats`,
        correctOpt: `C`
    },
    {
        id: 2,
        question: "What can you primarily do with the Zoom application?",
        option1: "Order food",
        option2: "Listen to music",
        option3: "Watch a web series",
        option4: "Attend a webinar",
        correct: "Attend a webinar",
        correctOpt: `D`
    },
    {
        id: 3,
        question: "Which organisation has the authority to declare global health emergencies as pandemics?",
        option1: "WTO",
        option2: "WGO",
        option3: "WHO",
        option4: "WIPO",
        correct: "WHO",
        correctOpt: `C`
    },
    {
        id: 4,
        question: `Which of these are names of national parks located in Madhya Pradesh?`,
        option1: `Krishna and Kanhaiya`,
        option2: `Kanha and Madhav`,
        option3: `Ghanshyam and Murari`,
        option4: `Girdhar and Gopal`,
        correct: `Kanha and Madhav`,
        correctOpt: `B`
    },
    {
        id: 5,
        question: "Which of these is not a country?",
        option1: "North Macedonia",
        option2: "East Timor (Timor-Leste)",
        option3: "West Indies",
        option4: "South Sudan",
        correct: "West Indies",
        correctOpt: `C`
    },
    {
        id: 6,
        question: "Who is the only leader to serve as deputy prime minister of India twice during the tenure of two different prime ministers?",
        option1: "Chaudhary Devi Lal",
        option2: "Morarji Desai",
        option3: "Yashwantrao Balwantrao Chavan",
        option4: "Chaudhary Charan Singh",
        correct: "Chaudhary Charan Singh",
        correctOpt: `D`
    },
    {
        id: 7,
        question: "Travis Dowlin is the only international wicket of which former Indian captain?",
        option1: "MS Dhoni",
        option2: "Mohd Azharuddin",
        option3: "Sunil Gavaskar",
        option4: "Rahul Dravid",
        correct: "MS Dhoni",
        correctOpt: `A`
    },
    {
        id: 8,
        question: " Azad Hind Radio was a radio service first started under the leadership of Netaji Subhas Chandra Bose in 1942 in which country?",
        option1: "Japan",
        option2: "Germany",
        option3: "Singapore",
        option4: "Burma",
        correct: "Germany",
        correctOpt: `B`
    },
    {
        id: 9,
        question: "Who scored highest number of runs in the ICC World Cup 2011?",
        option1: "Tillakaratne Dilshan",
        option2: "Gautam Gambhir",
        option3: "AB de Villiers",
        option4: "Sachin Tendulkar",
        correct: "Tillakaratne Dilshan",
        correctOpt: `A`
    },
    {
        id: 10,
        question: "Hephaestus was known as the god of which of the following in greek mythology?",
        option1: "God of War",
        option2: "God of Fire",
        option3: "God of Wine",
        option4: "God of Love",
        correct: "God of Fire",
        correctOpt: `B`
    },
    {
        id: 11,
        question: "Which was the first country to invent ice cream?",
        option1: "India",
        option2: "Bangladesh",
        option3: "Pakistan",
        option4: "China",
        correct: "China",
        correctOpt: `D`
    },
    {
        id: 12,
        question: "Who has been the only prime minister who has never won a Lok Sabha election?",
        option1: "H D Devegowda",
        option2: "Manmohan Singh",
        option3: "Inder Kumar Gujral",
        option4: "V P Singh",
        correct: "Manmohan Singh",
        correctOpt: `B`
    },
    {
        id: 12,
        question: "Which color cap is awarded to the player for scoring the most runs in the IPL?",
        option1: "Purple",
        option2: "Green",
        option3: "Orange",
        option4: "Blue",
        correct: "Orange",
        correctOpt: `C`
    },
    {
        id: 13,
        question: "Complete this Hindi idiom: Sau baat ki___",
        option1: "Pauni baat",
        option2: "Ek baat",
        option3: "Dedh baat",
        option4: "Aalo baat",
        correct: "Ek baat",
        correctOpt: `B`
    },
    {
        id: 14,
        question: "In which song this film feature? (Song: Ye Mausam ki barish, ye barish ka pani…)",
        option1: "Half Girlfriend",
        option2: "Baaghi",
        option3: "Ki & Ka",
        option4: "OK Jaanu",
        correct: "Half Girlfriend",
        correctOpt: `A`
    },
    {
        id: 15,
        question: "In which year was the Hatia (or Dhurva) Dam built?",
        option1: "1962-63",
        option2: "1952-53",
        option3: "1970-72",
        option4: "1945-47",
        correct: "1962-63",
        correctOpt: `A`
    },
    {
        id: 16,
        question: "In February 2017, ISRO created a world record by launching how many satellites through a single rocket?",
        option1: "34",
        option2: "96",
        option3: "154",
        option4: "104",
        correct: "104",
        correctOpt: `D`
    }
]
export default QUESTIONSDATA;